import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';

import { CLAIM_STATUS } from '../../shared/claimStatus';

import {
  StyledClaimStatusBlockedLabel,
  StyledClaimStatusCancelledLabel,
  StyledClaimStatusInfoLabel,
  StyledClaimStatusSuccessLabel,
} from './ClaimStatus.styled';

export default function ClaimStatus(props) {
  const { status } = props;

  switch (status) {
    case CLAIM_STATUS.CLOSED:
      return (
        <StyledClaimStatusSuccessLabel>
          <Typography variant="legalTexts" color="success">
            <FormattedMessage id={`claim_status_label.${status}`} />
          </Typography>
        </StyledClaimStatusSuccessLabel>
      );
    case CLAIM_STATUS.BLOCKED:
      return (
        <StyledClaimStatusBlockedLabel>
          <Typography variant="legalTexts" color="error">
            <FormattedMessage id={`claim_status_label.${status}`} />
          </Typography>
        </StyledClaimStatusBlockedLabel>
      );
    case CLAIM_STATUS.CANCELLED:
    case CLAIM_STATUS.DECLINED:
      return (
        <StyledClaimStatusCancelledLabel>
          <Typography variant="legalTexts" color="error">
            <FormattedMessage id={`claim_status_label.${status}`} />
          </Typography>
        </StyledClaimStatusCancelledLabel>
      );
    case CLAIM_STATUS.NEW:
    case CLAIM_STATUS.UPDATED:
    case CLAIM_STATUS.WAITING_FOR_INFORMATION:
    case CLAIM_STATUS.WAITING_FOR_PAYOUT:
    case CLAIM_STATUS.REIMBURSEMENT_ACKNOWLEDGED:
      return (
        <StyledClaimStatusInfoLabel>
          <Typography variant="legalTexts" color="info">
            <FormattedMessage id={`claim_status_label.${status}`} />
          </Typography>
        </StyledClaimStatusInfoLabel>
      );
    default:
      return (
        <StyledClaimStatusInfoLabel>
          <Typography variant="legalTexts" color="info">
            <FormattedMessage id={`claim_status_label.${CLAIM_STATUS.NEW}`} />
          </Typography>
        </StyledClaimStatusInfoLabel>
      );
  }
}
